import React, { useState, useCallback } from 'react';
import { Button, Collapse, Row, Col } from 'react-bootstrap';
import { ValidMessage, Options, SearchParams } from '../types/ProjectListStaff';
import SearchInput from '../molecules/SearchInput';
import SearchSelect from '../molecules/SearchSelect';
import SearchDate from '../molecules/SearchDate';
import Moment from 'moment';

interface Props {
  options: Options;
  search_params: SearchParams;
  handleClickSearch: () => void;
  handleChangeSearchParams: (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
  handleChangeDate: (event: Date) => void;
  handleClickClear: () => void;
  is_connecting: boolean;
  valid_message?: ValidMessage;
  handleBlurSearchParams: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchForm: React.FC<Props> = ({
  options,
  search_params,
  handleClickSearch,
  handleChangeSearchParams,
  handleChangeDate,
  handleClickClear,
  is_connecting,
  valid_message,
  handleBlurSearchParams,
}) => {
  // 検索条件表示フラグ
  const [is_search_area, setIsSearchArea] = useState(false);

  /**
   * 検索条件の表示切替えを行う
   */
  const isSeachArea = useCallback(() => {
    setIsSearchArea(!is_search_area);
  }, [is_search_area]);

  return (
    <div id="search">
      <Row className="hamburger-menu">
        <Col md={10}></Col>
        <Col md={2}>
          <Button variant="primary" onClick={isSeachArea}>
            <span>{is_search_area ? '▲' : '▼'}</span>
          </Button>
        </Col>
      </Row>
      <Collapse in={is_search_area}>
        <div className={`${is_search_area ? 'show' : ''}`}>
          <h3>検索条件</h3>
          <div className="search-area">
            <div className="row my-2">
              <SearchSelect
                label="担当店舗"
                name="store_in_charge"
                value={search_params.store_in_charge}
                handleChange={handleChangeSearchParams}
                options={options.dealer}
              />
              <SearchInput
                label="申込No"
                placeholder="申込No"
                value={search_params.application_no}
                handleChange={handleChangeSearchParams}
                max_length={12}
                name="application_no"
                valid_message={valid_message?.application_no}
              />
              <SearchInput
                label="名前(漢字)"
                placeholder="名前(漢字)"
                value={search_params.name}
                handleChange={handleChangeSearchParams}
                max_length={25}
                name="name"
                valid_message={valid_message?.name}
                handleBlur={handleBlurSearchParams}
              />
            </div>
            <div className="row my-2">
              <SearchInput
                label="口座番号"
                placeholder="口座番号"
                value={search_params.account_no}
                handleChange={handleChangeSearchParams}
                max_length={7}
                name="account_no"
                valid_message={valid_message?.account_no}
              />
              <SearchSelect
                label="ローン種類"
                name="loan_type"
                value={search_params.loan_type}
                handleChange={handleChangeSearchParams}
                options={[{ key: '', value: '全て' }].concat(options.loan_item)}
              />
              <SearchDate
                id="reception_date"
                label="受付日"
                name="reception_date"
                // handleBlur={handleBlurSearchParams}
                handleChange={handleChangeDate}
                value={
                  search_params.reception_date
                    ? new Date(Moment(search_params.reception_date).format('YYYY/MM/DD'))
                    : null
                }
                valid_message={valid_message?.reception_date}
              />
            </div>
            <div className="row my-2">
              <SearchSelect
                label="ステータス"
                name="status"
                value={search_params.status}
                handleChange={handleChangeSearchParams}
                options={[{ key: '', value: '全て' }].concat(options.status)}
              />
              <SearchSelect
                label="事前審査諾否"
                name="acceptance_or_disapproval"
                value={search_params.acceptance_or_disapproval}
                handleChange={handleChangeSearchParams}
                options={options.preliminary_decision}
              />
            </div>
            <div className="row my-2">
              <div className="col-md-8"></div>
              <div className="col-md-4">
                <Button
                  variant="outline-success"
                  className="search-button btn-text-color"
                  onClick={handleClickClear}
                >
                  クリア
                </Button>
                <Button
                  variant="success"
                  className="search-button"
                  onClick={handleClickSearch}
                  disabled={is_connecting}
                >
                  検索
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default SearchForm;
